import { PrivacyOptionsVariant } from '../../../types'
import isPostPrivacyVariant, {
  POST_TO_REPLY_PRIVACY_VARIANT,
} from '../isPostPrivacyVariant'

const checkPrivacyOptionVariant = (
  privacyOptionsVariant?: PrivacyOptionsVariant,
  isReply?: boolean,
): PrivacyOptionsVariant => {
  const defaultVariant = isReply
    ? PrivacyOptionsVariant.Reply
    : PrivacyOptionsVariant.Post

  if (isReply && isPostPrivacyVariant(privacyOptionsVariant)) {
    return (
      POST_TO_REPLY_PRIVACY_VARIANT[privacyOptionsVariant] ??
      privacyOptionsVariant
    )
  }

  return privacyOptionsVariant ?? defaultVariant
}
export default checkPrivacyOptionVariant
